import { render, staticRenderFns } from "./Step1-Footer.vue?vue&type=template&id=cf00556c&"
import script from "./Step1-Footer.vue?vue&type=script&lang=js&"
export * from "./Step1-Footer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports